<template>
  <div class="table-container">
    <FlexTable class="requirements-table">
      <div class="flex-th table-title">Cálculo de requerimientos</div>
      <div class="flex-trow flex-trow-header">
        <div class="flex-th">Fórmula</div>
        <div class="flex-th">Tasa metabólica basal</div>
        <div class="flex-th">Ajustado por actividad física</div>
        <div class="flex-th">Ajustado por objetivo</div>
      </div>
      <div class="flex-trow flex-trow-content">
        <div class="flex-td"> Carrasco </div>
        <div class="flex-td"> {{carrascoMetabolicRate}}* </div>
        <div class="flex-td"> {{carrascoPhysicalAdjusted}} </div>
        <div class="flex-td"> {{carrascoObjectiveAdjusted}} </div>
      </div>
      <div class="flex-trow flex-trow-content">
        <div class="flex-td"> FAO / OMS </div>
        <div class="flex-td"> {{faoMetabolicRate}} </div>
        <div class="flex-td"> {{faoPhysicalAdjusted}} </div>
        <div class="flex-td"> {{faoObjectiveAdjusted}} </div>
      </div>
      <div class="flex-trow flex-trow-content">
        <div class="flex-td"> Harris &amp; Benedict </div>
        <div class="flex-td"> {{harrisMetabolicRate}} </div>
        <div class="flex-td"> {{harrisPhysicalAdjusted}} </div>
        <div class="flex-td"> {{harrisObjectiveAdjusted}} </div>
      </div>
      <div class="flex-trow flex-trow-header">
        <div class="flex-th"> Promedio </div>
        <div class="flex-th"> {{meanMetabolicRate}} </div>
        <div class="flex-th"> {{meanPhysicalAdjusted}} </div>
        <div class="flex-th"> {{meanObjectiveAdjusted}} </div>
      </div>
      
    </FlexTable>
    <div class="table-footer">
      <small>(*) Ya considera una actividad física sedentaria</small>
    </div>
  </div>
</template>

<script>
import FlexTable from "./base/FlexTable";
import EditableCellInput from "../EditableCellInput";
import EditableCellSelect from '../EditableCellSelect';

export default {
  name: "RequirementsTable",
  components: { EditableCellSelect, EditableCellInput, FlexTable },
  props: {
    formData: {
      type: Object,
    },
  },
  data: function() {
    return {
      data: this.formData
    }
  },
  computed: {
    carrascoMetabolicRate: function () {
      let weight = this.formData.weight
      let height = this.formData.height
      if (this.isNotValid(weight) || this.isNotValid(height)) {
        return "--"
      }
      let bmi = weight / ( (height / 100)  * (height / 100) )
      if (bmi<18.5) {
        return (40 * weight)
      } else if (bmi>= 18.5 && bmi<25) {
        return (30 * weight)
      } else if (bmi>= 25 && bmi<30){
        return (25 * weight)
      } else if (bmi>= 30){
        return (20 * weight)
      } else {
        return "--"
      }
    },
    faoMetabolicRate: function () {
      let age = this.formData.age
      let weight = this.formData.weight
      let sex = this.formData.sex
      if (this.isNotValid(age) || this.isNotValid(weight) || this.isNotValid(sex)) {
        return "--"
      }
      switch (sex) {
        case 1:
          return this.getMenFaoMR(age, weight).toFixed(0)
        case 2:
          return this.getWomenFaoMR(age, weight).toFixed(0)
        default:
          return "--"
      }
    },
    harrisMetabolicRate: function () {
      let age = this.formData.age
      let weight = this.formData.weight
      let height = this.formData.height
      let sex = this.formData.sex
      if (this.isNotValid(age) || this.isNotValid(weight) || this.isNotValid(height) || this.isNotValid(sex)) {
        return "--"
      }
      switch (sex) {
        case 1:
          return this.getMenHarrisMR(age, weight, height).toFixed(0)
        case 2:
          return this.getWomenHarrisMR(age, weight, height).toFixed(0)
        default:
          return "--"
      }
    },
    meanMetabolicRate: function () {
      let carrasco = this.carrascoMetabolicRate
      let fao = this.faoMetabolicRate 
      let harris = this.harrisMetabolicRate
      return this.meanRequirements(carrasco, fao, harris)
    },
    carrascoPhysicalAdjusted: function () {
      let days = this.formData.workout_days
      let time = this. formData.workout_time
      let carrasco = this.carrascoMetabolicRate
      if (this.isNotValid(carrasco) || this.isNotValid(time) || this.isNotValid(days)) {
        return "--"
      }
      let calories = 0
      if (time == 1) {
        calories = 150
      } else if (time == 2) {
        calories = 225
      } else if (time == 3) {
        calories = 300
      } else if (time == 4) {
        calories = 450
      } else if (time == 5) {
        calories = 600
      } 
      return carrasco + Number(((calories * days) / 7).toFixed(0))
    },
    faoPhysicalAdjusted: function () {
      let fao = this.faoMetabolicRate
      let factor = this.formData.physical_activity_factor
      if(this.isNotValid(fao) || this.isNotValid(factor)) {
        return "--"
      }
      return (fao * factor).toFixed(0)
      
    },
    harrisPhysicalAdjusted: function () {
      let harris = this.harrisMetabolicRate
      let factor = this.formData.physical_activity_factor
      if(this.isNotValid(harris) || this.isNotValid(factor)) {
        return "--"
      }
      return (harris * factor).toFixed(0)
    },
    meanPhysicalAdjusted: function () {
      let carrasco = this.carrascoPhysicalAdjusted
      let fao = this.faoPhysicalAdjusted 
      let harris = this.harrisPhysicalAdjusted
      return this.meanRequirements(carrasco, fao, harris)
    },
    carrascoObjectiveAdjusted: function () {
      let carrasco = this.carrascoPhysicalAdjusted
      let symbol = this.formData.objective_symbol
      let adjustment = this.formData.objective_factor
      return this.adjustByObjective(carrasco, symbol, adjustment)
    },
    faoObjectiveAdjusted: function () {
      let fao = this.faoPhysicalAdjusted
      let symbol = this.formData.objective_symbol
      let adjustment = this.formData.objective_factor
      return this.adjustByObjective(fao, symbol, adjustment)
    },
    harrisObjectiveAdjusted: function () {
      let harris = this.harrisPhysicalAdjusted
      let symbol = this.formData.objective_symbol
      let adjustment = this.formData.objective_factor
      return this.adjustByObjective(harris, symbol, adjustment)
    },
    meanObjectiveAdjusted: function () {
      let carrasco = this.carrascoObjectiveAdjusted
      let fao = this.faoObjectiveAdjusted 
      let harris = this.harrisObjectiveAdjusted
      return this.meanRequirements(carrasco, fao, harris)
    }
  },
  methods: {
    getMenFaoMR(age, weight) {
      if ( age >= 0 && age < 4 ) {
        return (60.9 * weight) - 54
      } else if (age >= 4 && age <= 10) {
        return (22.7 * weight) + 495
      } else if (age >= 11 && age <= 18) {
        return (17.5 * weight) + 651
      } else if (age >= 19 && age <= 30) {
        return (15.3 * weight) + 679
      } else if (age >= 31 && age <= 60) {
        return (11.6 * weight) + 879
      } else if (age > 60) {
        return (13.5 * weight) + 487
      } else {
        return "--"
      }
    },
    getWomenFaoMR(age, weight) {
      if ( age >= 0 && age < 4 ) {
        return (61 * weight) - 51
      } else if (age >= 4 && age <= 10) {
        return (22.5 * weight) + 499
      } else if (age >= 11 && age <= 18) {
        return (12.2 * weight) + 746
      } else if (age >= 19 && age <= 30) {
        return (14.7 * weight) + 496
      } else if (age >= 31 && age <= 60) {
        return (8.7 * weight) + 829
      } else if (age > 60) {
        return (10.5 * weight) + 596
      } else {
        return "--"
      }
    },
    getMenHarrisMR(age, weight, height) {
      return 66.473 + (13.7516 * weight) + (5.0033 * height) - (6.775 * age)
    },
    getWomenHarrisMR(age, weight, height) {
      return 655.0955 + (9.5634 * weight) + (1.8449 * height) - (4.6756 * age)
    },
    isNotValid(number) {
      return isNaN(number) || number === "--"   
        || number === "" || number === null 
    },
    meanRequirements(carrasco, fao, harris) {
      if (carrasco==="--" || fao==="--" || harris==="--") {
        return "--"
      }
      let sum = Number(carrasco) + Number(fao) + Number(harris)
      return (sum/3).toFixed(0)
    },
    adjustByObjective(calories, symbol, adjustment) {
      if(this.isNotValid(calories) || this.isNotValid(symbol) || this.isNotValid(adjustment)) {
        return "--"
      }
      if (symbol === 2) {
        return Number(calories) - Number(adjustment)
      } else {
        return Number(calories) + Number(adjustment)
      }
    },
    validate() {
      this.$v.formData.$touch();
      var isValid = !this.$v.formData.$invalid
      this.$emit('on-validate', isValid)
      return isValid
    }
  }
}
</script>

<style scoped lang="scss">
$requirements-table-base-color: #517a51;
$requirements-table-title-bg-color: $requirements-table-base-color;
$requirements-table-title-color: $white;
$requirements-table-header-bg-color: rgba($requirements-table-base-color, 0.1);
$requirements-table-header-color: darken($requirements-table-base-color, 25);

.requirements-table {
  overflow-x: auto;
  padding: 4px;
  width: 100%;
  flex-direction: column;
  margin-bottom: 0rem;
}

.flex-th.table-title {
  background-color: $requirements-table-title-bg-color;
  color: white;
  position: sticky;
  left: 0;
  width: 100%;
}

.flex-th {
  background-color: $requirements-table-header-bg-color;
  color: $requirements-table-header-color;
  padding: 0.25rem;
}

.flex-trow-header > .flex-th, .flex-trow-content > .flex-td {
  flex: 1 0 6rem;
}

.flex-trow-header > .flex-th.num-cell, .flex-trow-content > .flex-td.num-cell {
  flex: 1 0 6rem;
}

.flex-trow-header > .flex-th.details-th, .flex-trow-content > .flex-td.details-td {
  flex: 1 0 27rem;
}

.with-unit {
  position: relative;

  & input {
    padding-top: 0;
    padding-bottom: 1rem;
  }

  & select {
    display: block;
    color: $gray-500;
    font-size: $font-size-sm;
    position: absolute;
    top: 50%;
    line-height: 1.3em;

    &:hover:not([disabled]) {
      color: $body-color;
    }

    &:hover[disabled] {
      background-color: transparent;
      cursor: unset;
    }

    &:active, &:focus {
      color: $body-color;
      background-color: $active-background-color;
    }
  }
}

.table-footer {
  text-align: right;
  padding-right: 0.5rem;
}
.table-container {
  padding-bottom: 1rem;
  padding-top: 0.5rem;
}

// Hide incremental arrows
/* Chrome, Safari, Edge, Opera */
.editable-cell input::-webkit-outer-spin-button,
.editable-cell input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
.editable-cell input[type=number] {
  -moz-appearance: textfield;
}
</style>